import React, { useState } from "react";
import { Auth } from "aws-amplify";
import { useHistory, useLocation, Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import LoaderButton from "../components/LoaderButton";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { onError } from "../libs/errorLib";
import admins from "../admins";
import "./Login.css";

export default function Login() {
  const history = useHistory();
  const search = useLocation().search;
  let mod = new URLSearchParams(search).get('m'); // Opration Type
  console.log('!!!! mod = ' + mod);
  mod = mod ? mod : 'rm';
  console.log('!!!! mod = ' + mod);
  const { userHasAuthenticated, userProfile, setUserProfile, setIsAdmin } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);

  const [fields, messages, handleFieldChange, doValidation] = useFormFields({
    loginId: "",
    password: ""
  },
  {
    loginId: {n:"", f: (value) => { console.log(value); return '' }},
    password: {n:"", f: (value) => { console.log(value); return '' }},
  });

  function validateForm() {
    return fields.loginId.length > 0 && fields.password.length > 0;
  }

  async function handleSubmit(event) {
    event.preventDefault();

    setIsLoading(true);

    try {
      await Auth.signIn(fields.loginId, fields.password);
      console.log("Success Logged in");
      const info = await Auth.currentUserInfo();
      console.log('After Login userInfo: ');
      console.log(info);
      if (info.attributes && info.attributes.preferred_username)
        setIsAdmin(admins.includes(info.attributes.preferred_username));
      setUserProfile(info);
      userHasAuthenticated(true);
//      history.push("/");
    } catch (e) {
      console.log('caught during login...');
      onError(e);
      setIsLoading(false);
    }
  }

  return (
    <div className="Login">
	  <h1 id="page_title">{ mod === 'ad' ? '管理者用管理画面' : ( mod === 'rm' ? '正会員' : ( mod === 'am' ? '准会員' : '学生会員') ) + 'マイページログイン画面' }</h1> 
      {//<h1 id="page_title">Login</h1>
      }
      <div id="sub_page">
      <div id="mypage" className="login">
      <section>
      <p>会員番号とパスワードを入力してください。<br/>会員番号は先頭から0（ゼロ）を追加して６桁を入力してください。<br/>（例：会員番号1111→001111を入力）</p>
      <Form onSubmit={handleSubmit}>
        <Form.Group size="lg" controlId="loginId">
          <Form.Label>会員番号</Form.Label>
          <Form.Control
            autoFocus
            type="text"
            value={fields.loginId}
            onChange={handleFieldChange}
          />
        </Form.Group>
        <Form.Group size="lg" controlId="password">
          <Form.Label>パスワード</Form.Label>
          <Form.Control
            type="password"
            value={fields.password}
            onChange={handleFieldChange}
          />
        </Form.Group>
        <LoaderButton
          block
          size="lg"
          type="submit"
          isLoading={isLoading}
          disabled={!validateForm()}
        >
          ログイン
        </LoaderButton>
      </Form>
      <p className="text-center"><Link to="/login/reset">※パスワードを忘れた方、変更したい方はこちら</Link></p>
      </section>
      </div>
      </div>
    </div>
  );
}
